/**
 * The measure every marketing page is set to.
 *
 * The ranking pages wrapped their whole route in one container and read as
 * deliberate. The category and city pages instead gave each section its own
 * `container mx-auto px-4` around an inner `mx-auto max-w-{N}`, with N varying
 * by section — 3xl for a hero, 5xl for a grid, 2xl for the copy under it.
 * Because each of those wrappers centred itself, the content's left edge
 * stepped inward and back out as the reader scrolled, which is what made the
 * headers look narrow and centred next to the grid below them.
 *
 * Held here rather than typed per section because the drift was the bug. Four
 * files each picking their own width is how they got out of step, and nothing
 * about a literal `max-w-2xl` in one section says it was supposed to match a
 * `max-w-5xl` three sections down.
 *
 * Sections keep their own vertical padding, and a full-bleed band still lives
 * outside this — the band spans the viewport, its contents sit on the measure.
 */
export const PAGE_MEASURE = 'container mx-auto max-w-5xl px-4'

/**
 * Prose inside the measure.
 *
 * Deliberately not `mx-auto`. Centring a narrower block inside the page is the
 * thing being fixed: body copy should keep its readable line length by pulling
 * its *right* edge in, while the left edge stays on the page's single spine.
 * Past roughly 75 characters a line gets measurably harder to track back to the
 * start of the next one, which is the only reason to narrow it at all.
 */
export const PAGE_PROSE = 'max-w-3xl'
